import api from './api';

// Params (all optional): { asOf, fromDate, toDate } as YYYY-MM-DD strings
const buildQuery = (params = {}) => {
  const queryParams = new URLSearchParams();
  ['asOf', 'fromDate', 'toDate'].forEach((key) => {
    if (params[key]) queryParams.append(key, params[key]);
  });
  const queryString = queryParams.toString();
  return queryString ? `?${queryString}` : '';
};

const fetchReport = async (path, params) => {
  try {
    const response = await api.get(`/contract-reports/${path}${buildQuery(params)}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching contract ${path} report:`, error);
    throw error;
  }
};

const contractReportsService = {
  getPerformanceReport: (params) => fetchReport('performance', params),
  getRenewalReport: (params) => fetchReport('renewals', params),
  getComplianceReport: (params) => fetchReport('compliance', params),
  getFinancialReport: (params) => fetchReport('financial', params),
};

export default contractReportsService;
